<script>
import Icon from 'fa-svelte'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight'

export let name
export let href


import { createEventDispatcher } from 'svelte';
import SGMSApi from './js/SGMSApi';
const dispatch = createEventDispatcher();

function handleClick(e) {
  if(name) {
    SGMSApi.sendActionEvent(e, name)
  }
  if(href) {
    window.open(href, '_blank')
  }

  dispatch("click")



}
</script>

<button class="button" on:click={handleClick}>
  <div class="button-bg-1" />
  <div class="button-bg-2" />
  <div class="button-bg-3" />

  <div class="button-content">
    <slot></slot>
    <span class="i"><Icon icon={faArrowRight}/></span>
  </div>
</button>



<style>

.button {
  position: relative;
  margin: 10px 0;
  display: inline-block;
  padding: 0;
}

.button-content:active { background: #dddddd; }

.button-content {
  font-size: 1.1em;
  padding: 15px;
  background: #FFF;
  z-index: 1;

  position: relative;
  user-select: none;
  cursor: pointer;

  display: inline-flex;
  justify-content: space-between;
  align-items: center;

}

.i {
  margin-left: 5px;
  float: right;
  color: #009edf;
}


.button:hover .button-bg-1,
.button:hover .button-bg-2,
.button:hover .button-bg-3 {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0px;
  background: #2FD9E7;
  z-index: 0;
  animation: glitch1 0.6s infinite linear;
  animation-timing-function: steps(10, end);
}

.button:hover .button-bg-2 {
  background: #3010e0;
  animation-name: glitch2;
  /* animation-delay: 0.2s; */
}
.button:hover .button-bg-3 { background: #bd11bd; animation-delay: 0.4s;}


@media screen and (max-width: 800px) {

  .button { display: block; }

  .button-content {
    font-size: 1em;
    /* padding: 10px; */
    width: 100%;
  }
}


@keyframes glitch1 {
  0% { transform: translateX(-2px) translateY(2px); }
  11% { transform: translateX(-2px) translateY(-1px); }
  22% { transform: translateX(3px) translateY(-2px); }
  33% { transform: translateX(-3px) translateY(-5px); }
  44% { transform: translateX(2px) translateY(-4px); }
  55% { transform: translateX(-2px) translateY(0px); }
  66% { transform: translateX(-5px) translateY(0px); }
  77% { transform: translateX(4px) translateY(-3px); }
  88% { transform: translateX(-4px) translateY(2px); }
  100% { transform: translateX(-3px) translateY(-1px); }
}
@keyframes glitch2 {
  0% { transform: translateX(2px) translateY(1px); }
  11% { transform: translateX(2px) translateY(-5px); }
  22% { transform: translateX(4px) translateY(2px); }
  33% { transform: translateX(0px) translateY(4px); }
  44% { transform: translateX(2px) translateY(-3px); }
  55% { transform: translateX(4px) translateY(4px); }
  66% { transform: translateX(2px) translateY(2px); }
  77% { transform: translateX(4px) translateY(-4px); }
  88% { transform: translateX(0px) translateY(3px); }
  100% { transform: translateX(3px) translateY(-1px); }
}
@keyframes glitch3 {
  0% { transform: translateX(-4px) translateY(-4px); }
  11% { transform: translateX(-1px) translateY(2px); }
  22% { transform: translateX(-5px) translateY(-4px); }
  33% { transform: translateX(-2px) translateY(-1px); }
  44% { transform: translateX(-4px) translateY(3px); }
  55% { transform: translateX(0px) translateY(0px); }
  66% { transform: translateX(-5px) translateY(4px); }
  77% { transform: translateX(4px) translateY(0px); }
  88% { transform: translateX(-5px) translateY(-1px); }
  100% { transform: translateX(-4px) translateY(-3px); }
}

</style>
